import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loginAuth } from "../redux/actions/auth.actions";
import { Button, Checkbox, CheckboxProps, Input, Radio, RadioChangeEvent } from "antd";
import "./Login-styles.scss";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../redux/store/hooks";
import {
  getAppIsInitialize,
  getAuthErrorMsg,
  getAuthIsLoading,
  getAuthIsLoggedIn,
} from "../redux/selectors";
import { LoadingOutlined } from "@ant-design/icons";
import { current } from "@reduxjs/toolkit";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState("admin");
  const isLoggedIn = useSelector(getAuthIsLoggedIn);
  const isInitialize = useSelector(getAppIsInitialize);
  const isLoading = useSelector(getAuthIsLoading);
  const errorMsg = useSelector(getAuthErrorMsg);
  const dispatch = useAppDispatch();
  const currentUser = localStorage.getItem("user");
  const [state, setState] = useState({
    login: "",
    password: "",
  });

  useEffect(() => {
    if (isLoggedIn) {
      if (value == "customer") navigate("/company");
      else if (value == "industry") navigate("/lk");
      else navigate("/main");
    } else navigate("/");
  }, [isLoggedIn]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    if (isLoading) {
      return;
    }

    dispatch(
      loginAuth({
        login: state.login,
        password: state.password,
      })
    );
  };

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  const options = [
    { label: "Войти как администратор", value: "admin" },
    { label: "Войти как предприятие", value: "industry" },
    { label: "Войти как заказчик", value: "customer" },
  ];

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);
    localStorage.setItem("usertype", value);
  };

  return (
    <div className="login">
      <div className="login__wrap">
        <div className="login__head">
          {isLoading ? "Выполняем вход..." : "Вход в систему"}
        </div>
        {isLoading ? (
          <div className="feed-posts-loader" style={{ height: "300px" }}>
            <LoadingOutlined />
          </div>
        ) : (
          <div className="login__body">
            <form
              data-testid="form"
              className="login__form"
              onSubmit={handleSubmit}
            >
              <Input
                type="text"
                placeholder="Логин"
                name="login"
                onChange={handleInput}
              />
              <Input
                type="password"
                placeholder="Пароль"
                name="password"
                onChange={handleInput}
              />

              <div className="login__row">
                <Button
                  data-testid="submit"
                  type="primary"
                  htmlType="submit"
                >
                  Войти
                </Button>
                {errorMsg !== "" && (
                  <div className="login__error">
                    Неправильный логин или пароль
                  </div>
                )}
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
